import { createWhenStepSchema } from './steps/when-step';
import { createHostStepSchema } from './steps/host-step';
import { createVisitStepSchema } from './steps/visit-step';
import type { VisitStepFieldsConfig } from './hooks/use-ui-metadata-field-config.hook';

export const createVisitFormV2Schema = (
  fieldsConfig: VisitStepFieldsConfig,
  includeHostStep = true,
  hasSelectableFloors = true,
) => {
  const whenSchema = createWhenStepSchema(fieldsConfig);
  const hostSchema = createHostStepSchema(fieldsConfig, hasSelectableFloors);
  const visitSchema = createVisitStepSchema(fieldsConfig);

  return includeHostStep ? whenSchema.and(hostSchema).and(visitSchema) : whenSchema.and(visitSchema);
};
